import { DayPickerProps } from "react-day-picker";
import "react-day-picker/dist/style.css";
import * as S from "./styles";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";

interface Props {
  open?: boolean;
  width?: string;
}

export const DatePicker = ({
  open,
  width,
  ...rest
}: DayPickerProps & Props) => {
  const currentYear = new Date().getFullYear();

  const { i18n } = useTranslation();

  const capitalize = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const dateTimeFormatted = (
    date: Date,
    options: Intl.DateTimeFormatOptions,
  ) => {
    return new Intl.DateTimeFormat(i18n.language, options).format(date);
  };

  const translatedMonthsOptions = (date: Date) => {
    const options = { month: "long" } as const;

    return dateTimeFormatted(date, options);
  };

  const translateWeekdayName = (date: Date) => {
    const options = { weekday: "short" } as const;

    const formattedWeekday = dateTimeFormatted(date, options);

    return formattedWeekday.endsWith(".")
      ? formattedWeekday.slice(0, -1)
      : formattedWeekday;
  };

  return open ? (
    <S.DayPickerComponent
      captionLayout="dropdown-buttons"
      formatters={{
        formatMonthCaption: (date) => {
          const capitalizedMonth = capitalize(translatedMonthsOptions(date));

          return capitalizedMonth;
        },
        formatWeekdayName: (date) => {
          const capitalizedWeekday = capitalize(translateWeekdayName(date));

          return capitalizedWeekday;
        },
      }}
      fromYear={2020}
      toYear={currentYear}
      width={width}
      {...rest}
    />
  ) : null;
};
